import { Button, ButtonProps } from '@my/ui'

interface SearchFiltersItemProps {
  label: string
  isActive?: boolean
  onPress: () => void
}

export const SearchFiltersItem = ({
  label,
  isActive,
  onPress,
  ...props
}: SearchFiltersItemProps & ButtonProps) => {
  return (
    <Button
      theme={isActive ? 'black' : 'white'}
      size="$4"
      br="$3"
      onPress={onPress}
      boc="$overlay6"
      color={isActive ? '$white' : '$overlay11'}
      pressStyle={{
        backgroundColor: '$backgroundPress',
        boc: '$overlay10',
      }}
      hoverStyle={{
        backgroundColor: '$backgroundHover',
        boc: '$overlay10',
      }}
      focusStyle={{
        outlineWidth: 0,
        backgroundColor: '$backgroundFocus',
        boc: '$overlay10',
      }}
      {...props}
    >
      {label}
    </Button>
  )
}
